/**
 * Cart Error Cleanup
 * Removes empty error elements from the DOM to prevent them from taking up space
 */

class CartErrorCleanup {
  constructor() {
    this.init();
  }

  init() {
    // Clean up errors on initial load
    this.cleanupEmptyErrors();

    // Watch for DOM mutations and clean up errors
    this.observeCartUpdates();
  }

  cleanupEmptyErrors() {
    // Find all error elements with empty text
    const errorElements = document.querySelectorAll('.cart-item__error');
    errorElements.forEach(errorEl => {
      const errorText = errorEl.querySelector('.cart-item__error-text');
      if (errorText && errorText.textContent.trim() === '') {
        errorEl.style.display = 'none';  // Hide instead of remove, so JS can populate it
      } else if (errorText && errorText.textContent.trim() !== '') {
        errorEl.style.display = 'block';  // Show if has error
      }
    });
  }

  observeCartUpdates() {
    const cartItemsContainer = document.querySelector('cart-drawer-items');

    if (!cartItemsContainer) return;

    const observer = new MutationObserver(() => {
      // Debounce cleanup to avoid multiple calls during updates
      clearTimeout(this.cleanupTimeout);
      this.cleanupTimeout = setTimeout(() => {
        this.cleanupEmptyErrors();
      }, 50);
    });

    observer.observe(cartItemsContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartErrorCleanup();
  });
} else {
  new CartErrorCleanup();
}
